module.exports = __webpack_public_path__ + "static/img/logo.0807658.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/downapp/img/logo.png
// module id = MO+G
// module chunks = 1